import { useDedupEffect } from "shared/hooks"
import { useDispatch, useSelector } from "react-redux";
import { DeviceValidationChecks, IADPState } from "shared/typings/AppStateTypes";
import { useRootDeviceValidationService } from "shared/hooks/useDeviceValidationService";
import { ScreenDialogue } from "@npd-ng/adp-component-library";
import { createRedirectToSCI, createSetViewAction } from "shared/state/reducer";
import { DeviceValidationWaitingView } from "./DeviceValidationWaitingView";
import { PUT_HEADER, PUT_HEADER_NCS } from "shared/util";

export const DeviceValidationLoadingView = (props:{
  healthUri:string,
  deviceMetricsURl:string,
  dataTransferUrl:string,
  putHeader:typeof PUT_HEADER | typeof PUT_HEADER_NCS,
  checks?: DeviceValidationChecks,
  cancelConfirmationModal: ()=>void
}
  ) => { 
    const state = useSelector((state:{rootState:IADPState})=>state.rootState)
    const {performDeviceValidation,postDeviceValidationLog} = useRootDeviceValidationService({
      healthURI:props.healthUri,
      deviceMetricsUrl:props.deviceMetricsURl,
      dataTransferUrl:props.dataTransferUrl,
      putHeader:props.putHeader})
    const dispatch = useDispatch();
    
  useDedupEffect(()=>{
    if(props.checks){
      performDeviceValidation(props.checks);
    }
    else {
      dispatch(createSetViewAction("DeviceValidationFailureView"))
    }
  },[])
 

  const submitConfirmationModal = () => {
    dispatch(createRedirectToSCI());
  }
  return (
    <>
      <DeviceValidationWaitingView  />
      {(state.sessionState.confirmationModal && state.sessionState.appAccessedFor == 'Assess') && (
        <>
          <ScreenDialogue
            title={state.currentLanguageContent?.accessCode.confirmationModal.title || ""}
            subTitle={state.sessionState?.schoolDetails?.location}
            confirmText={state.currentLanguageContent?.accessCode.confirmationModal.confirmText || ""}
            cancelText={state.currentLanguageContent?.accessCode.confirmationModal.cancelText || ""}
            onCancelAction={props.cancelConfirmationModal}
            onSubmitAction={submitConfirmationModal}
          ></ScreenDialogue>
        </>
      )}
    </>

  )
}